import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {

  resourcesList = [{name:'Audio notes- 10-11 (2)',icon:'icon-Audio-line'},{name:'video lessons- 08-11 (4)',icon:'icon-Incoming-call'},{name:'audio notes-Oct -04 (5)',icon:'icon-Miss-call'},{name:'science lesson audio -10 -11 (2)',icon:'icon-Outgoing-call'}]

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shelf/resources/resources.component.ts